"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Modal = require("@ccw-pwa-ui/Modal");
var _Input = require("@ccw-pwa-ui/Input");
var _HeaderText = require("@ccw-pwa-ui/HeaderText");
var _Header = require("@ccw-pwa-ui/Header");
var _Dropdown = require("@ccw-pwa-ui/Dropdown");
require("../styles/CreateProfileComponentStyle.css");
var _reactBootstrap = require("react-bootstrap");
var _index = _interopRequireDefault(require("../common_features/assets/images/index"));
var _Button = require("@ccw-pwa-ui/Button");
const CreateProfileComponent = props => {
  var _props$zipCode, _props$zipCode2, _props$phoneNumber, _props$phoneNumber2, _props$editModalData, _props$editModalData2, _props$editModalData3, _props$editModalData4, _props$editModalData5, _props$editModalData6, _props$editModalData7, _props$editModalData8, _props$editModalData9, _props$editModalData10, _props$editModalData11;
  const setRequiredFields = () => {
    return !props.firstName && !props.isLoading || false;
  };
  const setRequiredFieldsLastName = () => {
    return !props.lastName && !props.isLoading || false;
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "create-profile-screen"
  }, props.isHeaderVisible ? /*#__PURE__*/_react.default.createElement(_Header.Header, {
    imageUrl: props.headerImage,
    imageStyle: {
      height: 30,
      maxWidth: 100
    }
  }) : null, props.displayModal && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Modal.Modal, {
    displayModal: props.displayModal,
    modalHeaderText: props.modalHeaderText,
    modalHeaderTextStyle: props.modalHeaderTextStyle,
    modalDetailText: props.modalDetailText,
    modalHeaderIcon: props.modalHeaderIcon,
    displayCrossIcon: props.displayCrossIcon,
    variant: props.variant,
    positiveActionButtonTitle: props.positiveActionButtonTitle,
    positiveAction: props.positiveAction,
    negativeButtonActionTitle: props.negativeButtonActionTitle,
    crossIconAction: props.crossIconAction,
    negativeAvtion: props.negativeAvtion
  })), props.reInviteModalNP && /*#__PURE__*/_react.default.createElement(_Modal.Modal, {
    variant: props.inviteModalVarientNP,
    modalHeaderText: props.modalHeaderTextNP,
    modalHeaderTextStyle: {
      fontSize: 20,
      color: "#333333",
      fontWeight: 600,
      lineHeight: "25px"
    },
    modalDetailText: props.modalDetailTextNP,
    modalDetailTextStyle: {
      fontSize: 16,
      color: "#333333",
      fontWeight: 400,
      lineHeight: "22px"
    },
    displayModal: props.reInviteModalNP,
    positiveActionButtonTitle: props.positiveActionButtonTitleNP,
    negativeButtonActionTitle: props.negativeButtonActionTitleNP,
    positiveAction: props.handleResendInviteModalNP,
    negativeAvtion: props.handleSetReInviteCancelModalNP
  }), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Container, {
    className: "create-profile-container"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "create-profile-screen-title ".concat(props.onEditProfile ? "edit-profile-screen-title" : "", " ")
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    variant: "link-text",
    headerText: props.headerText
  })), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontSize: 16,
      color: '#333333',
      fontWeight: 400
    },
    variant: "header-text",
    headerText: props.headerSubText
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "create-profile-input-wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "create-profile-element-container ".concat(setRequiredFields() ? "P-error" : "")
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontSize: 16,
      color: '#333333'
    },
    variant: "header-text",
    headerText: props.firstNameText
  }), /*#__PURE__*/_react.default.createElement(_Input.Input, {
    inputStyle: {
      borderRadius: 10
    },
    placeholder: props.firstNameText,
    value: props.firstName,
    onchange: props.onChangeFirstName
  }), setRequiredFields() && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      color: "#E00932"
    }
  }, "This is a required field."), setRequiredFields() && /*#__PURE__*/_react.default.createElement("img", {
    src: _index.default.warning.default,
    alt: "",
    className: "input-warningIcontwo"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "create-profile-element-container ".concat(setRequiredFieldsLastName() ? "P-error" : "")
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontSize: 16,
      color: '#333333'
    },
    variant: "header-text",
    headerText: props.lastNameText
  }), /*#__PURE__*/_react.default.createElement(_Input.Input, {
    inputStyle: {
      borderRadius: 10
    },
    placeholder: props.lastNameText,
    value: props.lastName,
    onchange: props.onChangeLastName
  }), setRequiredFieldsLastName() && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      color: "#E00932"
    }
  }, "This is a required field."), setRequiredFieldsLastName() && /*#__PURE__*/_react.default.createElement("img", {
    src: _index.default.warning.default,
    alt: "",
    className: "input-warningIcontwo"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "create-profile-zip-country-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      maxWidth: '100%',
      width: '100%'
    },
    "data-testid": "countries"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontSize: 16,
      color: '#333333'
    },
    variant: "header-text",
    headerText: props.countryText
  }), /*#__PURE__*/_react.default.createElement(_Dropdown.Dropdown, {
    dropdownList: props.countryDropDownList,
    selectedItem: props.countries,
    itemClick: props.setCountry
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "create-profile-zip-container ".concat((!props.zipCode || props.isZipCodeValid) && !props.isLoading ? "P-error" : "")
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontSize: 16,
      color: '#333333',
      fontWeight: 600
    },
    variant: "header-text",
    headerText: props.zipCodeText
  }), /*#__PURE__*/_react.default.createElement(_Input.Input, {
    disabled: props.countries ? false : true,
    inputStyle: {
      borderRadius: 10
    },
    placeholder: props.zipCodeText,
    value: props.zipCode,
    onchange: props.setZipCode
  }), !((_props$zipCode = props.zipCode) !== null && _props$zipCode !== void 0 && _props$zipCode.length) && !props.isLoading && props.countries ? /*#__PURE__*/_react.default.createElement("div", {
    style: {
      color: "#E00932"
    }
  }, "This is a required field.") : ((_props$zipCode2 = props.zipCode) === null || _props$zipCode2 === void 0 ? void 0 : _props$zipCode2.length) !== 5 && props.isZipCodeValid && props.countries && !props.isLoading && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      color: "#E00932"
    }
  }, "Enter Valid Zipcode"), (!props.zipCode || props.isZipCodeValid) && props.countries && !props.isLoading && /*#__PURE__*/_react.default.createElement("img", {
    src: _index.default.warning.default,
    alt: "",
    className: "input-warningIcontwo"
  })), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginBottom: 24,
      position: 'relative'
    },
    "data-testid": "phone-input",
    className: "create-profile-phone-number ".concat(props.isPhoneNumberBlur ? "P-error" : "")
  }, /*#__PURE__*/_react.default.createElement(_Input.Input, {
    country: "us",
    dynamicTitleStyle: {
      color: '#333333',
      fontSize: 16
    },
    disableDropdown: true,
    countryCodeEditable: false,
    onlyCountries: ['us'],
    inputTitle: props.phoneNumberText,
    inputType: "phone-input",
    notificationText: props.notificationsText,
    value: props.phoneNumber,
    onchange: props.onChangePhoneNumber,
    isValidPhoneNumber: props.isValidPhoneNumber,
    numberInvalidText: props.numberInvalidText,
    phoneNumberInputClass: "".concat(((_props$phoneNumber = props.phoneNumber) === null || _props$phoneNumber === void 0 ? void 0 : _props$phoneNumber.length) > 10 || ((_props$phoneNumber2 = props.phoneNumber) === null || _props$phoneNumber2 === void 0 ? void 0 : _props$phoneNumber2.length) === undefined ? "phone-input1" : "phone-input2")
    // onBlur={() => props.handlePhoneNumberBlur(true)}
  }), !props.isValidPhoneNumber ? /*#__PURE__*/_react.default.createElement("img", {
    src: _index.default.warning.default,
    alt: "",
    className: "input-warning"
  }) : null), /*#__PURE__*/_react.default.createElement("div", {
    className: "create-profile-element-container"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontSize: 16,
      color: '#333333'
    },
    variant: "header-text",
    headerText: props.emailText
  }), /*#__PURE__*/_react.default.createElement(_Input.Input, {
    disabled: true,
    inputStyle: {
      borderRadius: 10
    },
    placeholder: props.emailPlaceholder,
    value: props.email,
    onchange: props.onChangeEmail
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "create-profile-element-container"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontSize: 16,
      color: '#333333'
    },
    variant: "header-text",
    headerText: props.organizationText
  }), /*#__PURE__*/_react.default.createElement(_Input.Input, {
    disabled: true,
    inputStyle: {
      borderRadius: 10
    },
    placeholder: props.organizationPlaceholder,
    value: props.organization,
    onchange: props.onChangeOrganization
  }))), props.editProfile ? /*#__PURE__*/_react.default.createElement("div", {
    style: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "create-nav-button-div",
    "data-testid": "Change Password"
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: "nav-primary",
    title: "Change Password",
    rightIcon: props.rightArrow,
    onClick: props.onCLickChangePassword,
    buttonStyle: {
      width: '100%'
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "create-nav-button-div",
    "data-testid": "Notification Preferences"
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: "nav-primary",
    title: "Notification Preferences",
    rightIcon: props.rightArrow,
    onClick: props.onCLickNotificationPreferences,
    buttonStyle: {
      width: '100%'
    }
  }))) : null, /*#__PURE__*/_react.default.createElement("div", {
    className: "create-profile-button-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "create-profile-button-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: "primary-long",
    title: props.saveButton,
    onClick: props.onClickSave,
    disabled: props.onClickSaveDisabled
    // disabled={true}
  })), props.isCancel ? /*#__PURE__*/_react.default.createElement("div", {
    className: "cancel-profile-button-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: "outline-primary-long",
    title: props.cancelButton,
    onClick: props.onClickCancel,
    buttonStyle: {
      borderRadius: 10
    }
  })) : null))), props.isLoading ? /*#__PURE__*/_react.default.createElement("div", {
    className: "spinner-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Spinner, {
    animation: "border"
  })) : null, props.showModal && /*#__PURE__*/_react.default.createElement(_Modal.Modal, {
    displayModal: props.showModal,
    variant: (_props$editModalData = props.editModalData) === null || _props$editModalData === void 0 ? void 0 : _props$editModalData.variant,
    displayCrossIcon: (_props$editModalData2 = props.editModalData) === null || _props$editModalData2 === void 0 ? void 0 : _props$editModalData2.displayCrossIcon,
    modalHeaderText: (_props$editModalData3 = props.editModalData) === null || _props$editModalData3 === void 0 ? void 0 : _props$editModalData3.modalHeaderText,
    modalHeaderTextStyle: (_props$editModalData4 = props.editModalData) === null || _props$editModalData4 === void 0 ? void 0 : _props$editModalData4.modalHeaderTextStyle,
    modalHeaderIcon: true,
    modalDetailText: (_props$editModalData5 = props.editModalData) === null || _props$editModalData5 === void 0 ? void 0 : _props$editModalData5.modalDetailText,
    modalDetailTextStyle: (_props$editModalData6 = props.editModalData) === null || _props$editModalData6 === void 0 ? void 0 : _props$editModalData6.modalDetailTextStyle,
    positiveActionButtonTitle: (_props$editModalData7 = props.editModalData) === null || _props$editModalData7 === void 0 ? void 0 : _props$editModalData7.positiveActionButtonTitle,
    negativeButtonActionTitle: (_props$editModalData8 = props.editModalData) === null || _props$editModalData8 === void 0 ? void 0 : _props$editModalData8.negativeButtonActionTitle,
    positiveAction: (_props$editModalData9 = props.editModalData) === null || _props$editModalData9 === void 0 ? void 0 : _props$editModalData9.positiveAction,
    negativeAvtion: (_props$editModalData10 = props.editModalData) === null || _props$editModalData10 === void 0 ? void 0 : _props$editModalData10.negativeAction,
    crossIconAction: (_props$editModalData11 = props.editModalData) === null || _props$editModalData11 === void 0 ? void 0 : _props$editModalData11.crossIconAction
  }));
};
var _default = exports.default = CreateProfileComponent;